import '../assets/js/main.js';
import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import Preloader from "../assets/js/preloader.js";
import { NavLink } from "react-router-dom";

import AnimatePage from './animatepage.js';

const Raffles = () => {

    const [countDownDates, setCountDownDates] = useState([
        new Date("Jan 30, 2023 09:00:00"),
        new Date("Jan 31, 2023 09:00:00"),
        new Date("Oct 30, 2026 09:00:00"),
        new Date("Dec 31, 2026 10:00:00")
    ]);

    useEffect(() => {
        let intervalIds = [];
        countDownDates.forEach((countDownDate, i) => {
            intervalIds[i] = setInterval(() => {
                let now = new Date().getTime();
                let distance = countDownDate - now;

                let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds = Math.floor((distance % (1000 * 60)) / 1000);

                let monthNames = ["STY", "LUT", "MAR", "KWI", "MAJ", "CZE", "LIP", "SIE", "WRZ", "PAŹ", "LIS", "GRU"];
                let day = countDownDate.getDate();
                let monthIndex = countDownDate.getMonth();
                let monthName = monthNames[monthIndex];
                let hour = countDownDate.getHours();

                document.querySelectorAll(".tmq")[i].innerHTML =
                    days + "d " + hours + "h" + "</span>";

                if (distance < 0) {
                    document.querySelectorAll(".tmq")[i].innerHTML =
                        "KONIEC" + "<span>" + day + " " + monthName + " " + hour + ":00</span>";
                    document.querySelectorAll(".tmq")[i].style = "height: 48px;background-color:#e42f2fc2";
                    document.querySelectorAll(".tmq")[i].parentNode.classList.add("expired");
                }
            }, 1000);
        });

        return () => {
            intervalIds.forEach(intervalId => clearInterval(intervalId));
        };
    }, [countDownDates]);


    return (
        <div>
            <AnimatePage>
                <section className="raffles">
                    <section className="home" style={{ minHeight: "100vh" }}>
                        <section className="drop">
                            <span className="item">
                                <img src="/img/maroon.png"></img>
                                <div className="name">Nike Dunk Low Retro<span>Maroon</span></div>
                                <div className="price">110.00 <span style={{ color: "#DAA520" }}>€</span></div>
                                <div className="tm tmq"><span></span></div>
                                <a href="" className="link">SKLEP</a>
                                <div className="resell"><i className="fa-solid fa-bolt-lightning"></i></div>
                                <div className="women"><i className="fa-solid fa-venus"></i></div>
                            </span>

                            <span className="item">
                                <img src="./img/midnightnv.png"></img>
                                <div className="name">Nike Air Force 1 '07<span>Midnight Navy</span></div>
                                <div className="price">145.00 <span style={{ color: "#DAA520" }}>€</span></div>
                                <div className="tm tmq"><span></span></div>
                                <a href="" className="link">SKLEP</a>
                                <div className="resell s"><i className="fa-solid fa-bolt-lightning"></i></div>
                                <div className="women"><i className="fa-solid fa-venus"></i></div>
                            </span>

                            <span className="item">
                                <img src="./img/sail.png"></img>
                                <div className="name">Nike Air Jordan 1<span>Sail</span></div>
                                <div className="price">830 <span style={{ color: "#DAA520" }}>PLN</span></div>
                                <div className="tm tmq"><span></span></div>
                                <a href="" className="link">SKLEP</a>
                                <div className="resell s"><i className="fa-solid fa-bolt-lightning"></i></div>
                                <div className="women"><i className="fa-solid fa-venus"></i></div>
                            </span>

                            <span className="item">
                                <img src="./img/ucla.png"></img>
                                <div className="name">Nike Blazer<span>UCLA</span></div>
                                <div className="price">230.00 <span style={{ color: "#DAA520" }}>$</span></div>
                                <div className="tm tmq"><span></span></div>
                                <a href="" className="link">SKLEP</a>
                                <div className="resell s"><i className="fa-solid fa-bolt-lightning"></i></div>
                                <div className="women s"><i className="fa-solid fa-venus"></i></div>
                            </span>
                        </section>
                    </section>
                </section>
            </AnimatePage>
        </div>
    );
}

export default Raffles;
